document.addEventListener('DOMContentLoaded', function () {
  var locale = getLocale();
  setupDateNavigation();
  setupLecturerFilter();
  setupLinkedDatePickers(locale);
  setupToggle();
});

function getLocale() {
  var pathSegments = window.location.pathname.split('/').filter(Boolean);
  var lang = pathSegments[0] === 'cs' ? 'cs' : 'en';

  if (lang === 'cs') {
    return {
      weekdays: {
        shorthand: ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'],
        longhand: ['Neděle', 'Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Pátek', 'Sobota'],
      },
      months: {
        shorthand: ['Led', 'Úno', 'Bře', 'Dub', 'Kvě', 'Čer', 'Čvc', 'Srp', 'Zář', 'Říj', 'Lis', 'Pro'],
        longhand: ['Leden', 'Únor', 'Březen', 'Duben', 'Květen', 'Červen', 'Červenec', 'Srpen', 'Září', 'Říjen', 'Listopad', 'Prosinec'],
      },
      firstDayOfWeek: 1,
    };
  }

  return {
    weekdays: {
      shorthand: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      longhand: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    },
    months: {
      shorthand: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      longhand: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    },
    firstDayOfWeek: 0,
  };
}

function setupLinkedDatePickers(locale) {
  var fromButton = document.getElementById('datePickerButtonFrom');
  var toButton = document.getElementById('datePickerButtonTo');
  var fromInput = document.querySelector('input[name="overview_filter_form[selected_day]"]');
  var toInput = document.querySelector('input[name="overview_filter_form[date_to]"]');

  if (!fromButton || !toButton || !fromInput || !toInput) return;

  var fromDateStr = fromButton.dataset.date || fromInput.value;
  var toDateStr = toButton.dataset.date || toInput.value;
  var fromDate = fromDateStr ? new Date(fromDateStr + 'T00:00:00') : new Date();
  var toDate = toDateStr ? new Date(toDateStr + 'T00:00:00') : new Date();

  var fromFp, toFp;

  fromFp = flatpickr(fromButton, {
    locale: locale,
    mode: 'single',
    dateFormat: 'j. n. Y',
    defaultDate: [fromDate],
    showMonths: 1,
    inline: false,
    onChange: function (selectedDates) {
      var date = selectedDates[0];
      fromInput.value = formatDateForInput(date);
      if (toFp) toFp.set('minDate', date);
      submitDateForm();
    },
    onOpen: function () {
      fromButton.classList.add('is-active');
    },
    onClose: function () {
      fromButton.classList.remove('is-active');
    },
  });

  toFp = flatpickr(toButton, {
    locale: locale,
    mode: 'single',
    dateFormat: 'j. n. Y',
    defaultDate: [toDate],
    minDate: fromDate,
    showMonths: 1,
    inline: false,
    onChange: function (selectedDates) {
      var date = selectedDates[0];
      toInput.value = formatDateForInput(date);
      submitDateForm();
    },
    onOpen: function () {
      toButton.classList.add('is-active');
    },
    onClose: function () {
      toButton.classList.remove('is-active');
    },
  });
}

function formatDateForInput(date) {
  var year = date.getFullYear();
  var month = String(date.getMonth() + 1).padStart(2, '0');
  var day = String(date.getDate()).padStart(2, '0');
  return year + '-' + month + '-' + day;
}

function setupToggle() {
  var toggleContainer = document.getElementById('toggleContainer');
  var viewModeSelect = document.querySelector('.view-mode-input');
  var toggleButtons = document.querySelectorAll('.toggle__item');

  toggleButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      if (toggleContainer.dataset.viewmode !== button.dataset.view) {
        if (viewModeSelect) {
          viewModeSelect.value = button.dataset.view;
        }
        if (button.dataset.view === 'calendar') {
          var searchCompanyInput = document.querySelector('[name="overview_filter_form[search_company]"]');
          var searchTitleInput = document.querySelector('[name="overview_filter_form[search_title]"]');
          if (searchCompanyInput) searchCompanyInput.value = '';
          if (searchTitleInput) searchTitleInput.value = '';
        }
        var form = document.querySelector('#overviewFilterForm');
        if (form) {
          form.submit();
        }
      }
    });
  });
}

// Lecturer Filter Functionality
function setupLecturerFilter() {
  var expandButton = document.getElementById('lecturerExpandButton');
  var avatarContainers = document.querySelectorAll('.lecturer-filter__avatar-container');
  var lecturerFilter = document.getElementById('lecturerFilter');
  var isExpanded = false;
  var selectedLecturers = new Set();

  // Load selected lecturers from form
  loadSelectedLecturers();

  // Expand/Collapse functionality
  if (expandButton) {
    expandButton.addEventListener('click', function () {
      isExpanded = !isExpanded;
      toggleAvatarVisibility(isExpanded);
      updateExpandButton(isExpanded);
    });
  }

  // Avatar click handlers
  avatarContainers.forEach(function (container) {
    var avatar = container.querySelector('.lecturer-filter__avatar');
    var removeButton = container.querySelector('.lecturer-filter__remove');
    var lecturerId = container.dataset.lecturerId;

    // Avatar click - toggle selection
    avatar.addEventListener('click', function (e) {
      if (e.target.closest('.lecturer-filter__remove')) {
        return; // Don't toggle if clicking remove button
      }
      toggleLecturerSelection(lecturerId, container);
    });

    // Remove button click
    if (removeButton) {
      removeButton.addEventListener('click', function (e) {
        e.stopPropagation();
        removeLecturerFromSelection(lecturerId, container);
      });
    }
  });

  function toggleAvatarVisibility(expand) {
    var containers = document.querySelectorAll('.lecturer-filter__avatar-container');
    containers.forEach(function (container, index) {
      if (index >= 7) {
        if (expand) {
          container.style.display = 'block';
          container.classList.add('is-expanding');
          setTimeout(function () {
            container.classList.remove('is-expanding');
          }, 300);
        } else {
          container.classList.add('is-collapsing');
          setTimeout(function () {
            container.style.display = 'none';
            container.classList.remove('is-collapsing');
          }, 300);
        }
      }
    });
  }

  function updateExpandButton(expanded) {
    if (expandButton) {
      var totalContainers = document.querySelectorAll('.lecturer-filter__avatar-container').length;
      var visibleCount = expanded ? totalContainers : Math.min(7, totalContainers);
      var hiddenCount = Math.max(0, totalContainers - visibleCount);

      if (expanded) {
        expandButton.textContent = '−';
        expandButton.classList.add('is-expanded');
        expandButton.title = 'Collapse lecturer list';
      } else {
        expandButton.textContent = '+' + hiddenCount;
        expandButton.classList.remove('is-expanded');
        expandButton.title = 'Show ' + hiddenCount + ' more lecturers';
      }
    }
  }

  function toggleLecturerSelection(lecturerId, container) {
    var avatar = container.querySelector('.lecturer-filter__avatar');

    if (selectedLecturers.has(lecturerId)) {
      selectedLecturers.delete(lecturerId);
      avatar.classList.remove('is-active');
    } else {
      selectedLecturers.add(lecturerId);
      avatar.classList.add('is-active');
    }

    updateFormWithSelectedLecturers();
  }

  function removeLecturerFromSelection(lecturerId, container) {
    var avatar = container.querySelector('.lecturer-filter__avatar');
    selectedLecturers.delete(lecturerId);
    avatar.classList.remove('is-active');

    updateFormWithSelectedLecturers();
  }

  function reorderAvatars() {
    var avatarsContainer = document.querySelector('.lecturer-filter__avatars');
    var expandButtonEl = document.getElementById('lecturerExpandButton');

    if (!avatarsContainer) return;

    var allContainers = Array.from(avatarsContainer.querySelectorAll('.lecturer-filter__avatar-container'));

    var sortedContainers = allContainers.sort(function (a, b) {
      var aId = a.dataset.lecturerId;
      var bId = b.dataset.lecturerId;
      var aSelected = selectedLecturers.has(aId);
      var bSelected = selectedLecturers.has(bId);

      if (aSelected !== bSelected) {
        return bSelected - aSelected;
      }

      const aOrder = a.dataset.sortOrder !== '' ? parseInt(a.dataset.sortOrder) : Infinity;
      const bOrder = b.dataset.sortOrder !== '' ? parseInt(b.dataset.sortOrder) : Infinity;
      if (aOrder !== bOrder) return aOrder - bOrder;

      return (a.dataset.lecturerName || '').localeCompare(b.dataset.lecturerName || '', 'cs', { sensitivity: 'base' });
    });

    if (expandButtonEl) {
      expandButtonEl.remove();
    }

    sortedContainers.forEach(function (container, index) {
      avatarsContainer.appendChild(container);

      if (index >= 7 && !isExpanded) {
        container.style.display = 'none';
      } else {
        container.style.display = 'block';
      }
    });

    if (expandButtonEl && allContainers.length > 7) {
      avatarsContainer.appendChild(expandButtonEl);
      updateExpandButton(isExpanded);
    }
  }

  function loadSelectedLecturers() {
    var lecturerCheckboxes = document.querySelectorAll('input[name="overview_filter_form[lecturers][]"]:checked');

    if (lecturerCheckboxes.length > 0) {
      lecturerCheckboxes.forEach(function (checkbox) {
        var lecturerUuid = checkbox.value;
        selectedLecturers.add(lecturerUuid);

        var container = document.querySelector('[data-lecturer-id="' + lecturerUuid + '"]');
        if (container) {
          container.querySelector('.lecturer-filter__avatar').classList.add('is-active');
        }
      });

      if (selectedLecturers.size > 0) {
        reorderAvatars();
      }
    }
  }

  function updateFormWithSelectedLecturers() {
    var lecturerCheckboxes = document.querySelectorAll('input[name="overview_filter_form[lecturers][]"]');

    if (lecturerCheckboxes.length > 0) {
      lecturerCheckboxes.forEach(function (checkbox) {
        var lecturerUuid = checkbox.value;
        var isSelected = selectedLecturers.has(lecturerUuid);
        checkbox.checked = isSelected;
      });
      submitDateForm();
    }
  }
}

function setupDateNavigation() {
  var todayButton = document.getElementById('today');
  var prevButton = document.getElementById('prevDates');
  var nextButton = document.getElementById('nextDates');
  var viewModeSelect = document.querySelector('.view-mode-input');
  var startInput = document.querySelector('input[name="overview_filter_form[selected_day]"]');
  var endInput = document.querySelector('input[name="overview_filter_form[date_to]"]');
  var form = document.querySelector('#overviewFilterForm');

  if (!form) return;

  if (todayButton) {
    todayButton.addEventListener('click', function () {
      var today = new Date();
      var todayPlus30 = new Date();
      todayPlus30.setDate(todayPlus30.getDate() + 30);
      if (startInput) startInput.value = formatDateForInput(today);
      if (endInput) endInput.value = formatDateForInput(todayPlus30);
      form.submit();
    });
  }

  function parseDateLocal(str) {
    return str ? new Date(str + 'T00:00:00') : new Date();
  }

  function getRange() {
    if (viewModeSelect && viewModeSelect.value === 'calendar') return 7;
    if (startInput && endInput && startInput.value && endInput.value) {
      var start = parseDateLocal(startInput.value);
      var end = parseDateLocal(endInput.value);
      var diff = Math.round((end - start) / (1000 * 60 * 60 * 24));
      return diff > 0 ? diff : 30;
    }
    return 30;
  }

  function navigateRange(direction) {
    var step = getRange();
    var currentStart = parseDateLocal(startInput ? startInput.value : null);
    var currentEnd = endInput && endInput.value ? parseDateLocal(endInput.value) : new Date(new Date().setDate(new Date().getDate() + 30));

    var newStart = new Date(currentStart);
    var newEnd = new Date(currentEnd);
    newStart.setDate(newStart.getDate() + (direction === 'next' ? step : -step));
    newEnd.setDate(newEnd.getDate() + (direction === 'next' ? step : -step));

    if (startInput) startInput.value = formatDateForInput(newStart);
    if (endInput) endInput.value = formatDateForInput(newEnd);
    form.submit();
  }

  if (prevButton)
    prevButton.addEventListener('click', function () {
      navigateRange('prev');
    });
  if (nextButton)
    nextButton.addEventListener('click', function () {
      navigateRange('next');
    });
}

function submitDateForm() {
  var form = document.querySelector('#overviewFilterForm');
  if (form) {
    try {
      form.submit();
    } catch (error) {
      console.error('Form submission failed:', error);
    }
  }
}
